export const PATHS = {
  DASHBOARD: '/',
  POST_MANAGEMENT: '/posts',
  DONOR_MANAGEMENT: '/donors',
  PAYMENT_STATUS: '/payments',
  PROJECT_MANAGEMENT: '/project',
  PROJECT_SETTINGS: '/project/settings',
  NEW_PROJECT: '/project/new',
  MY_ACCOUNT: '/account',
  LOGIN: '/login',
  SIGNUP: '/signup',
};

